import { API } from '../../../../config';
import { errorHandler } from '../../auth/errorAction';

export const unmountListJobPostingType = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_JOB_POSTING_TYPE'})
}

export const unmountDetailJobPostingType = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_JOB_POSTING_TYPE'})
}

export const unmountMasterJobPostingType = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_JOB_POSTING_TYPE'})
}

export const listJobPostingType = (meta) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_JOB_POSTING_TYPE' })
  return API.GET('/job_posting_type/list', meta).then((response) => {
    dispatch({
      type: 'LOAD_DATA_JOB_POSTING_TYPE_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: response.meta.page,
          total: response.meta.total,
          perpage: response.meta.perpage
        }
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_JOB_POSTING_TYPE_FAILED' }), 
    ))
  })
}

export const detailJobPostingType = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_JOB_POSTING_TYPE' })
  const params = {
    'id': id
  }
  API.GET('/job_posting_type/getById', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_JOB_POSTING_TYPE_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_JOB_POSTING_TYPE_FAILED' }), 
      ))
    )
  })
}

export const masterJobPostingType = (successCB, failedCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_JOB_POSTING_TYPE' })
  return API.GET('/job_posting_type/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_JOB_POSTING_TYPE_SUCCESS', 
      payload: { data: response.data }
    })
    return successCB && successCB(response.data)
  }).catch((err) => {
    failedCB && failedCB()
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_MASTER_JOB_POSTING_TYPE_FAILED' }), 
    ))
  })
}

export const createJobPostingType = (value, successCB, failedCB) => () => {
  API.POST_NO_PARAMS('/job_posting_type/add', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const editJobPostingType = (value, successCB, failedCB) => () => {
  API.POST_NO_PARAMS('/job_posting_type/update', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const enableJobPostingType = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/job_posting_type/enable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const disableJobPostingType = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/job_posting_type/disable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}